/* Great Lakes Lavender Farm — Contact page. Keeps the original contact[...] field names and routing. */
(function () {
  "use strict";
  var root = document.getElementById("glc");
  if (!root || root.__glc) return;
  root.__glc = true;
  root.classList.remove("glc-nojs");
  var RM = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var DKEY = "gllfContactDraftV1";
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  function jsonOf(s) { try { return JSON.parse($(s).textContent); } catch (e) { return {}; } }
  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }
  var saveDraft = function () {};
  function fOf(el) { return el.closest(".glc-f"); }
  function markBad(el, bad) { var f = fOf(el); if (f) f.classList.toggle("is-bad", !!bad); el.setAttribute("aria-invalid", bad ? "true" : "false"); }
  function clearBad(el) { markBad(el, false); }
  var ROUTES = jsonOf("[data-glc-routes]"), GUIDES = jsonOf("[data-glc-guides]");

  /* ---------- scrolling ---------- */
  function headerBottom() {
    var b = 0;
    document.querySelectorAll(".shopify-section-group-header-group, #shopify-section-header, sticky-header").forEach(function (h) {
      var p = getComputedStyle(h).position; if (p !== "sticky" && p !== "fixed") return;
      var r = h.getBoundingClientRect(); if (r.top <= 2 && r.bottom > b && r.height < innerHeight / 2) b = r.bottom;
    });
    return b;
  }
  var lastTop = -1;
  function syncTop() { var t = Math.round(headerBottom()); if (t !== lastTop) { lastTop = t; root.style.setProperty("--top", t + "px"); } }
  syncTop(); setInterval(function () { if (!document.hidden) syncTop(); }, 250);
  function go(sel, focusEl) {
    var t = typeof sel === "string" ? document.querySelector(sel) : sel; if (!t) return;
    window.scrollTo({ top: t.getBoundingClientRect().top + pageYOffset - headerBottom() - 16, behavior: RM ? "auto" : "smooth" });
    if (focusEl) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, RM ? 0 : 650);
  }
  $$("[data-glc-go]").forEach(function (a) { a.addEventListener("click", function (e) { e.preventDefault(); go(a.getAttribute("data-glc-go"), $("#GLLFContactTopic")); }); });

  /* ---------- chat ---------- */
  function openChat() {
    try { if (window.GLLFGrower && typeof GLLFGrower.open === "function") { GLLFGrower.open(); return; } } catch (e) {}
    var l = document.querySelector(".lg-launcher"); if (l) { l.click(); return; }
    location.href = "/pages/lavender-grower-chat";
  }
  root.addEventListener("click", function (e) { var b = e.target.closest && e.target.closest("[data-glc-chat]"); if (b) { e.preventDefault(); openChat(); } });

  /* ---------- pickup status (Eastern time) ---------- */
  (function () {
    var el = $("[data-glc-pickup]"), sub = $("[data-glc-pickup-sub]"); if (!el) return;
    try {
      var p = {}; new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", year: "numeric", month: "numeric", day: "numeric", hour: "numeric", hour12: false, weekday: "short" })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      var base = new Date(+p.year, +p.month - 1, +p.day), hr = +p.hour % 24;
      for (var i = 0; i < 8; i++) {
        var d = new Date(base); d.setDate(base.getDate() + i); var wd = d.getDay();
        if (wd !== 3 && wd !== 5) continue;
        if (i === 0 && hr >= 15) continue;
        var nice = d.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
        el.textContent = i === 0 ? (hr >= 10 ? "Pickup is open now" : "Pickup today") : i === 1 ? "Next pickup: tomorrow" : "Next pickup: " + nice;
        sub.textContent = (i < 2 ? nice + " · " : "") + "10am–3pm Eastern · placed orders";
        break;
      }
    } catch (e) {}
  })();

  /* ---------- form ---------- */
  var form = document.getElementById("GLLFContactForm");
  var topic = document.getElementById("GLLFContactTopic");
  var guide = $("[data-glc-guide]");
  function renderGuide(v) {
    if (!guide) return;
    var g = GUIDES[v] || GUIDES._default; if (!g) return;
    guide.innerHTML = '<div class="glc-guide__top"><img src="' + g.art + '" alt="" width="72" height="72"><div><p class="k">What to include</p><h3>' + g.title + "</h3></div></div><ul>" +
      g.items.map(function (i) { return "<li>" + esc(i) + "</li>"; }).join("") + "</ul>" +
      (g.links.length ? '<div class="glc-links">' + g.links.map(function (l) { return '<a href="' + l[1] + '">' + l[0] + "</a>"; }).join("") + "</div>" : "") +
      '<div class="glc-guide__route"><span aria-hidden="true">➜</span><span>' + (v ? "Goes straight to our <b>" + esc(g.team) + "</b>" : "We&rsquo;ll route it to the <b>right team</b>") + "</span></div>";
    guide.classList.remove("is-swap"); void guide.offsetWidth; guide.classList.add("is-swap");
  }
  function sync() {
    if (!topic) return;
    var v = topic.value, route = ROUTES[v] || ["info@greatlakeslavenderfarm.com", "CUSTOMERS/Retail"];
    var wholesale = v === "Wholesale / Commercial" || v === "Wholesale Support" || v === "Custom / Private Label";
    var order = v === "Order Question" || v === "Shipping Question" || v === "Deposit / Balance" || v === "Local Pickup";
    var business = wholesale || ["Marketing / Social", "Vendor / Supplier", "Accounting", "Legal / Compliance", "DMCA", "Partnership / Media"].indexOf(v) !== -1;
    var sim = v.indexOf("Simulator ") === 0;
    var show = { GLLFWholesaleRouter: wholesale, GLLFOrderFields: order, GLLFPickupFields: v === "Local Pickup", GLLFClaimFields: v === "Claim / Damage / Warranty", GLLFBusinessFields: business, GLLFSimulatorFields: sim };
    Object.keys(show).forEach(function (id) { var n = document.getElementById(id); if (n) n.hidden = !show[id]; });
    var re = document.getElementById("GLLFContactRoutingEmail"), rl = document.getElementById("GLLFContactRoutingLabel");
    if (re) re.value = route[0]; if (rl) rl.value = route[1];
    $$("[data-glc-topic]").forEach(function (b) { if (b.classList.contains("glc-tile")) b.setAttribute("aria-pressed", b.getAttribute("data-glc-topic") === v ? "true" : "false"); });
    renderGuide(v);
    if (v) clearBad(topic);
  }
  function setTopic(v, scroll) {
    if (!topic) return;
    topic.value = v; sync(); saveDraft();
    if (scroll) go("#contact-form", document.getElementById("glc-body") && !/Claim/.test(v) ? document.getElementById("glc-body") : topic);
  }
  root.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-glc-topic]"); if (!b) return;
    e.preventDefault(); setTopic(b.getAttribute("data-glc-topic"), true);
  });
  // legacy links from other pages: data-gcx-topic
  document.querySelectorAll("[data-gcx-topic]").forEach(function (l) { l.addEventListener("click", function () { setTimeout(function () { setTopic(l.getAttribute("data-gcx-topic"), false); }, 100); }); });

  var success = $("[data-glc-success]:not([hidden])");
  if (success) { try { localStorage.removeItem(DKEY); } catch (e) {} setTimeout(function () { go("#contact-form"); }, 300); }

  if (form && topic) {
    var sp = document.getElementById("GLLFSubmittedPage"), bd = document.getElementById("GLLFBrowserDevice");
    if (sp) sp.value = location.href; if (bd) bd.value = navigator.userAgent;
    topic.addEventListener("change", function () { sync(); saveDraft(); });

    /* draft (topic, order, message only — stays on this device) */
    var body = document.getElementById("glc-body"), order = document.getElementById("glc-order"), cnt = $("[data-glc-count]"), dn = $("[data-glc-draft]"), dt;
    function count() { if (cnt && body) cnt.textContent = body.value.length.toLocaleString() + " / 5,000"; }
    saveDraft = function () {
      clearTimeout(dt);
      dt = setTimeout(function () {
        try {
          var d = { t: topic.value, b: body ? body.value : "", o: order ? order.value : "" };
          if (!d.b && !d.o) { localStorage.removeItem(DKEY); return; }
          localStorage.setItem(DKEY, JSON.stringify(d));
          if (dn) { dn.classList.add("is-on"); clearTimeout(dn.__t); dn.__t = setTimeout(function () { dn.classList.remove("is-on"); }, 1800); }
        } catch (e) {}
      }, 500);
    };
    try {
      var d = JSON.parse(localStorage.getItem(DKEY) || "null");
      if (d && !$(".glc-errors")) { if (d.t && ROUTES[d.t]) topic.value = d.t; if (body && d.b && !body.value) body.value = d.b; if (order && d.o && !order.value) order.value = d.o; }
    } catch (e) {}
    // ?topic= prefill from other pages
    try { var q = new URLSearchParams(location.search).get("topic"); if (q && ROUTES[q]) topic.value = q; } catch (e) {}
    if (body) body.addEventListener("input", function () { count(); saveDraft(); if (body.value.trim().length >= 10) clearBad(body); });
    if (order) order.addEventListener("input", saveDraft);
    count();

    /* pickup date: Wednesdays & Fridays only */
    var pd = document.getElementById("glc-pickdate");
    if (pd) {
      var t = new Date(); t.setMinutes(t.getMinutes() - t.getTimezoneOffset()); pd.min = t.toISOString().slice(0, 10);
      pd.addEventListener("change", function () { var ok = checkPickup(); markBad(pd, !ok); });
    }
    function checkPickup() {
      if (!pd || !pd.value || pd.closest("[hidden]")) return true;
      var wd = new Date(pd.value + "T12:00:00").getDay(); return wd === 3 || wd === 5;
    }

    /* validation */
    var nameEl = document.getElementById("glc-name"), mailEl = document.getElementById("glc-email");
    [nameEl, mailEl].forEach(function (el) { if (el) el.addEventListener("input", function () { if (fOf(el).classList.contains("is-bad")) validate(el); }); });
    function validate(el) {
      var v = (el.value || "").trim(), bad = false;
      if (el === mailEl) bad = !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      else if (el === body) bad = v.length < 10;
      else bad = !v;
      markBad(el, bad); return !bad;
    }
    form.addEventListener("submit", function (e) {
      var firstBad = null;
      [topic, nameEl, mailEl, body].forEach(function (el) { if (el && !validate(el) && !firstBad) firstBad = el; });
      if (pd && !checkPickup()) { markBad(pd, true); firstBad = firstBad || pd; }
      if (firstBad) { e.preventDefault(); go(fOf(firstBad) || firstBad, firstBad); return; }
      var btn = $("[data-glc-send]"); if (btn) { btn.classList.add("is-busy"); btn.setAttribute("aria-busy", "true"); $("[data-t]", btn).textContent = "Sending…"; }
      if (sp) sp.value = location.href;
    });
    var errs = $("[data-glc-errs]"); if (errs) setTimeout(function () { go(errs, errs); }, 300);
    sync();
  } else renderGuide("");

  /* ---------- mobile: show the guide right under the topic ---------- */
  (function () {
    var side = $(".glc-side"), anchor = topic && topic.closest(".glc-f"); if (!guide || !side || !anchor || !window.matchMedia) return;
    var mq = matchMedia("(max-width: 900px)");
    function place() { if (mq.matches) anchor.parentNode.insertBefore(guide, anchor.nextSibling); else side.insertBefore(guide, side.firstChild); guide.classList.toggle("glc-guide--inline", mq.matches); }
    place(); if (mq.addEventListener) mq.addEventListener("change", place); else if (mq.addListener) mq.addListener(place);
  })();

  /* ---------- reveal ---------- */
  if ("IntersectionObserver" in window && !RM) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } }); }, { rootMargin: "0px 0px -6% 0px", threshold: .06 });
    $$(".glc-rv").forEach(function (n) { io.observe(n); });
  } else $$(".glc-rv").forEach(function (n) { n.classList.add("is-in"); });

  // deep links (#contact-form, #wholesale, …) after layout
  if (location.hash && /^#(contact-form|help|orders|growers|wholesale)$/.test(location.hash)) setTimeout(function () { go(location.hash); }, 250);
})();
